import ReactGA from 'react-ga4';

const isProd = import.meta.env.VITE_ENV === 'production';
export const gaTrackingId = import.meta.env.VITE_GA_TRACKING_ID;

// Helper to check if GA is properly configured
export const isGAEnabled = (): boolean => {
  return isProd && !!gaTrackingId;
};

// Initialize Google Analytics
if (isGAEnabled()) {
  ReactGA.initialize(gaTrackingId);
}

// Track pageview
export const trackPageview = (path: string, title?: string) => {
  if (!isGAEnabled()) return;
  ReactGA.send({
    hitType: 'pageview',
    page: path,
    title: title,
  });
};

// Track event
export const trackEvent = (
  category: string,
  action: string,
  label?: string,
  value?: number,
  nonInteraction: boolean = false
) => {
  if (!isGAEnabled()) return;
  ReactGA.event({
    category,
    action,
    label,
    value,
    nonInteraction,
  });
};

// Set user
export const setUser = (userId: string) => {
  if (!isGAEnabled()) return;
  ReactGA.set({ userId });
};
